module.exports = __webpack_public_path__ + "static/media/developASideIncome.126b4ab6.svg";